module.exports = __webpack_public_path__ + "static/media/14_tiger_dong.4cbe2efe.png";